import { render } from "./GuideProfile.vue?vue&type=template&id=3f80f0be"
import script from "./GuideProfile.vue?vue&type=script&lang=js"
export * from "./GuideProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__